import React from 'react';
import { Alert, Box, Link, SpaceBetween } from '@amzn/awsui-components-react';

export const ATP_ACCESS_GUIDE_URL = 'https://w.amazon.com/bin/view/FinanceTechnology/Intercompany/I3/ClientAccess/';
export const ATP_SUPPORT_TEAM = 'FT-IC-TP-Tech';

// Shown when sign-in fails. That covers both users without access and users whose stored
// login session could not be refreshed, so the message must not assume a missing group.
export default function AppRestrict() {
  return (
    <Box padding='xxl'>
      <Alert type='warning' header='Access restricted'>
        <SpaceBetween size='s'>
          <Box variant='p'>We couldn't sign you in to the Transfer Pricing Engine (ATP).</Box>
          <Box variant='p'>
            <strong>If you don't have access yet:</strong> follow the manager access request steps in the{' '}
            <Link href={ATP_ACCESS_GUIDE_URL} external>ATP access guide</Link> to request access.
          </Box>
          <Box variant='p'>
            <strong>If you already have access:</strong> refresh this page, or open ATP in a private/incognito
            window and sign in again.
          </Box>
          <Box variant='p'>
            If the issue persists, please reach out to the {ATP_SUPPORT_TEAM} team for help.
          </Box>
        </SpaceBetween>
      </Alert>
    </Box>
  );
}
